import {Box} from '@material-ui/core'
import {Skeleton} from '@mui/material'
import React from 'react'

type UserInformationInputSkeletonProps = {
  single?: boolean
  firstRowWidth?: number
  firstRowheight?: number
  secondRowWidth?: number
  secondRowheight?: number
}
export const UserInformationInputSkeleton = ({
  firstRowWidth,
  firstRowheight,
  secondRowheight,
  secondRowWidth,
  single = false
}: UserInformationInputSkeletonProps) => {
  return (
    <Box style={{padding: '5px 0'}}>
      <Skeleton width={firstRowWidth || 250} height={firstRowheight || 30}></Skeleton>
      {!single && (
        <Skeleton width={secondRowWidth || 200} height={secondRowheight || 30}></Skeleton>
      )}
    </Box>
  )
}
